import { z } from 'zod'

// Где сработало совпадение: имя самой сущности или имя навешанного тэга.
// Палитра рисует по нему бейдж «по тегу».
export const MatchedInSchema = z.enum(['name', 'tag']).catch('name')
export type MatchedIn = z.infer<typeof MatchedInSchema>

// Единый ответ /api/search (employee-only). Зеркалит форму мока: четыре группы
// с контекстом для deep-link «{company} › {project}». snake_case end-to-end.
export const ProjectHitSchema = z.object({
  id: z.string(),
  title: z.string(),
  slug: z.string(),
  priority: z.number().nullable().optional(),
  company: z.object({ id: z.string(), name: z.string(), slug: z.string() }),
  matched_in: MatchedInSchema.optional(),
})
export type ProjectHit = z.infer<typeof ProjectHitSchema>

export const CompanyHitSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  project_count: z.number(),
  matched_in: MatchedInSchema.optional(),
})
export type CompanyHit = z.infer<typeof CompanyHitSchema>

// owner — реальный владелец слота (project/company/task/invoice/meeting). project и
// company несут контекст навигации: у документов проекта и его детей (task/…)
// проставлены оба, у документов компании — только company.
export const DocumentHitSchema = z.object({
  id: z.string(),
  title: z.string(),
  slot_id: z.string(),
  owner: z.object({ kind: z.string(), id: z.string() }),
  project: z.object({ slug: z.string(), title: z.string() }).nullable(),
  company: z.object({ slug: z.string(), name: z.string() }).nullable(),
  matched_in: MatchedInSchema.optional(),
})
export type DocumentHit = z.infer<typeof DocumentHitSchema>

export const TaskHitSchema = z.object({
  id: z.string(),
  title: z.string(),
  done: z.boolean(),
  due: z.string().nullable().optional(),
  project: z.object({ slug: z.string(), title: z.string() }),
  company: z.object({ slug: z.string(), name: z.string() }),
  matched_in: MatchedInSchema.optional(),
})
export type TaskHit = z.infer<typeof TaskHitSchema>

export const SearchResponseSchema = z.object({
  projects: z.array(ProjectHitSchema),
  companies: z.array(CompanyHitSchema),
  documents: z.array(DocumentHitSchema),
  tasks: z.array(TaskHitSchema),
})
export type SearchResponse = z.infer<typeof SearchResponseSchema>
